class MenuDrawer extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.querySelector('.menu-drawer__content');

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.mainDetailsToggle.setAttribute('aria-expanded', true);
    }

    this.mainDetailsToggle.addEventListener('mouseenter', this.onMouseEnter.bind(this));
    this.mainDetailsToggle.addEventListener('mouseleave', this.onMouseLeave.bind(this));
  }

  onMouseEnter() {
    this.mainDetailsToggle.setAttribute('open', true);
    this.mainDetailsToggle.setAttribute('aria-expanded', true);
  }

  onMouseLeave() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.setAttribute('aria-expanded', false);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class CartDrawer extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'true');
    cartLink.setAttribute('aria-controls', 'cart-drawer');
    cartLink.setAttribute('aria-expanded', 'false');
  }

  open() {
    this.classList.add('animate', 'active');
    this.setAttribute('aria-hidden', false);
    document.body.classList.add('overflow-hidden');
    trapFocus(this, this.querySelector('.drawer__inner'), false);
  }

  close() {
    this.classList.remove('active');
    this.setAttribute('aria-hidden', true);
    document.body.classList.remove('overflow-hidden');
    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') && this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
      if (sectionElement && sectionElement.parentElement) {
        sectionElement.parentElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      }
    });

    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '.cart-drawer'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }
}

customElements.define('cart-drawer', CartDrawer);

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  container.setAttribute('tabindex', '-1');
  elementToFocus.focus();

  function handleKeyDown(e) {
    if (e.key !== 'Tab') return;

    if (e.shiftKey) {
      if (document.activeElement === first) {
        last.focus();
        e.preventDefault();
      }
    } else if (document.activeElement === last) {
      first.focus();
      e.preventDefault();
    }

    container.setAttribute('tabindex', '-1');
  }

  container.addEventListener('keydown', handleKeyDown);
  container.focused = true;
}

function removeTrapFocus(elementToFocus = null) {
  document.querySelectorAll('[tabindex="-1"]').forEach((element) => {
    element.setAttribute('tabindex', '0');
  });
  if (elementToFocus) elementToFocus.focus();
}

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:not([disabled]), [tabindex]:not([tabindex='-1']), [draggable], area, input:not([type=hidden]):not([disabled]), select:not([disabled]), textarea:not([disabled]), object, embed, [contenteditable]"
    )
  );
}



